export const trackPage = ({ name, path }) => {
  self.gtag('config', 'UA-5544272-3', {
    page_title: name || path,
    page_path: path,
  })
}
